document.addEventListener('turbolinks:load', function (event) {
  if (typeof dataLayer === 'undefined') return

  dataLayer.push({
    event: 'pageview',
    virtualUrl: event.data.url,
  })
})
